import Cancel from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import ContentManagementInterface from '../../models/ContentManagementInterface';
import { StyledButton } from '../styles/StyledButtons';
import { StyledCard, StyledCardContent, StyledHeading, StyledTypography } from '../styles/styles';
import { FundOpportunityEOIInstance } from './controller';
import { FundOpportunityEOIContentPanel } from './FundOpportunityEOIContentPanel';

export function FundOpportunityEOIPageView({
  instance,
}: {
  instance: FundOpportunityEOIInstance;
}): JSX.Element {
  // Show invitation acceptance success page
  if (instance.state.invitationAccepted) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          p: 2,
        }}
      >
        <StyledCard tone="tone1" sx={{ maxWidth: 500 }}>
          <StyledCardContent sx={{ py: 3, textAlign: 'center' }}>
            <CheckCircleIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
            <StyledHeading headerVariant="heading2" sx={{ mb: 2 }}>
              Invitation Accepted!
            </StyledHeading>
            <StyledTypography sx={{ mb: 3 }}>
              You will receive a verification email to complete your sign up by setting a password.
            </StyledTypography>
            <StyledTypography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
              Please check your email and follow the instructions to set up your account.
            </StyledTypography>
            <StyledButton variant="contained" onClick={() => (window.location.href = '/')}>
              Go to Home
            </StyledButton>
          </StyledCardContent>
        </StyledCard>
      </Box>
    );
  }

  // Show invitation acceptance error page
  if (instance.state.invitationAcceptError) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          p: 2,
        }}
      >
        <StyledCard tone="tone1" sx={{ maxWidth: 500 }}>
          <StyledCardContent sx={{ py: 3, textAlign: 'center' }}>
            <Cancel sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
            <StyledHeading headerVariant="heading2" sx={{ mb: 2 }}>
              Failed to Accept Invitation
            </StyledHeading>
            <StyledTypography sx={{ mb: 3 }}>
              {instance.state.invitationAcceptError}
            </StyledTypography>
            <StyledButton variant="contained" onClick={() => (window.location.href = '/')}>
              Go to Home
            </StyledButton>
          </StyledCardContent>
        </StyledCard>
      </Box>
    );
  }

  return (
    <>
      {(() => {
        if (!instance.state.contentManagementInterface && !instance.state.newTemplate) {
          return (
            <Box
              sx={{
                pt: 5,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '30vh',
              }}
            >
              <CircularProgress />
            </Box>
          );
        }
        return instance.state.contentManagementInterface || instance.state.newTemplate ? (
          <>
            {(instance.state.newTemplate || instance.state.contentManagementInterface) && (
              <FundOpportunityEOIContentPanel
                instance={instance}
                contentManagementInterface={
                  instance.state.contentManagementInterface as ContentManagementInterface
                }
              />
            )}
          </>
        ) : (
          <Box
            sx={{
              pt: 5,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '30vh',
            }}
          >
            <CircularProgress />
          </Box>
        );
      })()}
    </>
  );
}
